<template>
  <div class="card-panel flex justify-space-between">
    <div
      class="card-icon"
      :class="type"
    >
      <i :class="icon" />
    </div>
    <div class="card-data">
      <h4>{{ title }}</h4>
      <h2>{{ value }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    icon() {
      if (this.type === 'new-candidate-accounts') {
        return 'el-icon-user-solid'
      }
      else if (this.type === 'new-company-accounts') {
        return 'el-icon-s-cooperation'
      }
      else if (this.type === 'completed-assessments') {
        return 'el-icon-s-order'
      }

      return 'el-icon-warning-outline'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .card-panel {
    min-width: 80%;
    overflow: hidden;
    padding: $-padding-unit * 2;
    background-color: $-color-white;
    border-radius: $-border-radius;
    box-shadow: 0px 0px 25px 0px rgba(0,0,0,0.1);

    .card-icon {
      font-size: 60px;
    }

    .card-data {
      text-align: right;
    }
  }

  .new-candidate-accounts {
    color: #40c9c6;
  }

  .new-company-accounts {
    color: #f4516c;
  }

  .completed-assessments {
    color: #36a3f7;
  }

  .expiring-leads {
    color: #ff9b33;
  }
</style>
